import { render, staticRenderFns } from "./PriceMRS.vue?vue&type=template&id=4aed2d68&scoped=true&"
import script from "./PriceMRS.vue?vue&type=script&lang=js&"
export * from "./PriceMRS.vue?vue&type=script&lang=js&"
import style0 from "./PriceMRS.vue?vue&type=style&index=0&id=4aed2d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed2d68",
  null
  
)

export default component.exports